import { getLowestPrice } from '@modules/price/parsers';
import { fireLinkTag } from './tagManager';

/**
 * @typedef {object} params
 * @property {string} radioValue
 * @property {import('@modules/price/parsers').TEMPSelectedPrice} selectedPrice
 * @property {import('../../modules/availability/types').ProductInfo} productInfo
 * @property {number} [quantity]
 */

/**
 * @param {params} params
 * @returns {void}
*/
export function tagAvailabilityRadioChange({
  productInfo, radioValue, selectedPrice, quantity = 1,
}) {
  const { bossAvailability = false, bopsAvailability = false, isBossUpc = false } = productInfo?.pickup || {};
  const isShippingSelected = radioValue === 'ShipIt';
  const isPickupSelected = radioValue === 'Pickup';

  let method = isShippingSelected ? 'ship' : 'pickup';
  if (isPickupSelected && isBossUpc) {
    method = 'boss';
  }

  fireLinkTag({
    event_name: 'pdp change fulfilment method',
    link_name: 'pdp change fulfilment method',
    product_id: [productInfo.productId.toString()],
    product_name: [productInfo.productName],
    product_upc: [productInfo.selectedUpcId.toString()],

    product_price: [getLowestPrice(selectedPrice)?.toString() || ''],
    product_quantity: [quantity.toString()],

    product_fulfillment_method: [method],
    product_boss_select: [isBossUpc.toString()],
    product_bops_select: [isPickupSelected.toString()],
    product_boss_available: [bossAvailability?.toString()],
    product_bops_available: [bopsAvailability?.toString()],
  });
}

export default { tagAvailabilityRadioChange };
